enum CustomerType {
  LEGAL = 'J',
  NATURAL = 'F',
}

export default CustomerType;
